export const nullSafeFn = <T, U>(fn: Function, list: T): U | null =>
  list === null ? null : fn(list);
